import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Pickup = () => <PlaceholderPage title="수거/배송" description="수거·배송 일정을 관리해요." />;

export default Pickup;
